import React from 'utils/react';
import logo from 'assets/SWAT-Icon-Orange.png';

import Container from './Container';

import ImgLogo from './ImgLogo';

const Logo = () => (
  <Container>
    <ImgLogo src={logo} alt='GADP' />
  </Container>
);

export default React.memo(Logo);
